module.exports = __webpack_public_path__ + "static/people-ai-analytics-4ca7fa79dffd47493106cda95d969bed.png";